import "./App.css";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import globalStyles from "./theme/global.module.css";
import { Blank, Spacer, Img, Div } from "./components";
import ontag_logo from "./resources/images/ontag_logo.png";
import ontag from "./resources/images/ontag.png";
import qr_nfc from "./resources/images/qr_nfc.png";
import button_text from "./resources/images/button_text.png";
import button from "./resources/images/button.png";
import www_ontag_co_kr from "./resources/images/www_ontag_co_kr.png";
import text1 from "./resources/images/text1.png";
import google_play from "./resources/images/google_play.png";
import app_store from "./resources/images/app_store.png";
import { isMobile, isIOS } from "react-device-detect";
import exax from "./resources/images/logo-dx@2x.png";

const App = (props) => {
  const renderPCOrMobile = () => {
    if (!isMobile) {
      return (
        <div
          className={classNames(
            globalStyles.flex,
            globalStyles.row,
            globalStyles.justifyCenter
          )}
        >
          <Img
            src={google_play}
            width={208}
            height={71}
            onClick={() => {
              // console.log("");
              window.open(
                "https://play.google.com/store/apps/details?id=com.koreanfc.m_tag&hl=ko&gl=US",
                "_blank"
              );
            }}
          ></Img>
          <Spacer width={14} />
          <Img
            src={app_store}
            width={208}
            height={71}
            onClick={() => {
              window.open(
                "https://apps.apple.com/us/app/%EC%98%A8%ED%83%9C%EA%B7%B8/id1603372795",
                "_blank"
              );
            }}
          ></Img>
        </div>
      );
    }
    return (
      <Div
        className={"blue_button"}
        height={71}
        onClick={() => {
          if (!isIOS) {
            window.open(
              "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details&id=com.koreanfc.m_tag&hl=ko&gl=US",
              "_blank"
            );
          } else {
            window.open(
              "itms-apps://itunes.apple.com/app/id1603372795",
              "_blank"
            );
          }
        }}
      >
        <Img src={button} width={260} height={71}></Img>
        <div className={"button_bg"}>
          <div className={classNames(globalStyles.flex, globalStyles.center)}>
            <Img src={button_text} width={132} height={25} />
          </div>
        </div>
      </Div>
    );
  };
  const renderFooter = () => {
    if (isMobile) {
      return (
        <div>
          <Img src={www_ontag_co_kr} width={196} height={27} />
          <Blank height={50} />
        </div>
      );
    }
    return (
      <div
        style={{
          width: "100%",
          height: "138px",
          backgroundColor: "rgb(234,234,234)",
        }}
      >
        <div
          style={{
            marginTop: "24px",
            marginLeft: "200px",
            textAlign: "left",
            // display: "flex",
            // alignItems: "flex-start",
          }}
        >
          <img src={exax} alt="phone" width="118px" height="15px" />
          <div
            style={{
              marginTop: "14px",
              fontSize: "12px",
              fontWeight: "200",
              color: "#6F6F6F",
              textAlign: "left",
              lineHeight: 0,
            }}
          >
            (주)이그잭스 디엑스 | 충청남도 천안시 서북구 2공단7길 50 | 대표번호:
            070-4639-3611 | 이메일:madincom@exax.co.kr
          </div>
          <div
            style={{
              marginTop: "9px",
              fontSize: "12px",
              fontWeight: "200",
              color: "#6F6F6F",
              textAlign: "left",
              lineHeight: 1.59,
            }}
          >
            대표이사: 정욱재 | 사업자등록번호 614-86-00953
          </div>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "200",
              color: "#6F6F6F",
              textAlign: "left",
              lineHeight: 1.59,
              display: "flex",
              flexDirection: "row",
            }}
          >
            개인정보관리책임자: 오준희 macincom@exax.co.kr | &nbsp;
            <a href="https://www.ontag.co.kr/policy/온태그 이용약관.html">
              {" "}
              이용약관{" "}
            </a>
            &nbsp; | &nbsp;
            <a href="https://www.ontag.co.kr/policy/온태그 개인정보 처리방침.html">
              개인정보처리방침
            </a>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={"App"}>
      <div className={classNames(globalStyles.flex, globalStyles.alignCenter)}>
        <Blank height={133} />
        <Img src={ontag_logo} width={120} height={120} />
        <Blank height={25} />
        <Img src={ontag} width={190} height={41} />
        <Blank height={64} />
        <Img src={text1} width={429} height={179} />
        <Blank height={66} />
        <Img src={qr_nfc} width={526} height={64} />
        <Blank height={74} />
        {renderPCOrMobile()}
        <Blank height={135} />
        {/* <Img src={www_ontag_co_kr} width={196} height={27} /> */}
        {renderFooter()}
      </div>
    </div>
  );
};

{
}
export default App;
